import * as React from "react";
import Button from "../../../components/Button";
import TextField from "../../../components/TextField";

interface ISupportFaqHeader {
    onFilter: (event: React.FormEvent<{}>, newValue: string) => void;
    getActiveFaqs: () => void;
    filterValue?: string;
    t: reactI18Next.TranslationFunction;
}

export const SupportFaqHeader: React.SFC<ISupportFaqHeader> = (props: ISupportFaqHeader) => {

    return (
        <React.Fragment>
            <div>
                <Button
                    label={props.t("GLOBAL:RELOAD")}
                    labelPosition="after"
                    icon="refresh"
                    onClick={props.getActiveFaqs}
                />
            </div>
            <TextField
                placeholder={props.t("SUPPORT_FAQ:FILTER_FAQ")}
                value={props.filterValue}
                onChange={props.onFilter}
            />
        </React.Fragment>
    );
};

export default SupportFaqHeader;



// WEBPACK FOOTER //
// ./src/views/SupportView/SupportFaqTab/SupportFaqHeader.tsx